import { environment } from '../../../../environments/environment'
import { type CartoClient } from './carto.helper'

export interface CompareDeliveriesRow {
  region_id: string
  id: number
  name: string
  nvisitors: number
  nvisitors_other: number
  delivery_id: number
  delivery_id_other: number
  tags: string
  properties: string
  lng: number
  lat: number
  delivery_belongs: number // 1 = only d1, 2 = only d2, 3 = both
  belongs_to_d1: number
  belongs_to_d2: number
}

export interface CompareDeliveriesFilters {
  delivery_id_1: number
  delivery_start_date_1: string
  delivery_id_2: number
  delivery_start_date_2: string
  filter_combined: string
  tag_groups: number[][]
}

export async function fetchCompareDeliveries(
  cartoClient: CartoClient,
  filters: CompareDeliveriesFilters,
  signal?: AbortSignal,
): Promise<CompareDeliveriesRow[]> {
  const {
    delivery_id_1,
    delivery_start_date_1,
    delivery_id_2,
    delivery_start_date_2,
    filter_combined,
    tag_groups,
  } = filters

  const response = await cartoClient.query<CompareDeliveriesRow>({
    source: {
      source: `${environment.CARTO_SOURCE_PREFIX}_compare_two_deliveries`,
      queryParameters: {
        delivery_id_1,
        delivery_start_date_1,
        delivery_id_2,
        delivery_start_date_2,
        filter_combined,
        tag_groups: JSON.stringify(tag_groups ?? []),
      },
    },
    params: {
      column: [
        'region_id',
        'id',
        'name',
        'nvisitors',
        'nvisitors_other',
        'delivery_id',
        'delivery_id_other',
        'tags',
        'properties',
        'lng',
        'lat',
        'delivery_belongs',
        'belongs_to_d1',
        'belongs_to_d2',
      ],
    },
    signal,
  })

  return response?.rows ?? []
}
